import ENV from "@/env";
import { supabase } from "./supabase"

export async function getTokenPrice(tokenProcess: string, type: "usd" | "token"): Promise<number> {
  const { data, error } = await supabase.functions.invoke('hopper', {
    body: {
      baseToken: type === "usd" ? tokenProcess : "USD",
      quoteToken: type === "usd" ? "USD" : tokenProcess,
      priceOnly: true,
    }
  })

  if (error) {
    throw new Error(`Supabase function error: ${error.message}`)
  }

  if (!data) {
    throw new Error("No response from hopper")
  }

  // New style response: nested object under `Prices`.
  if (data.Prices) {
    const tokenKey = type === "usd" ? tokenProcess : "USD"

    const nested = data.Prices[tokenKey]

    // The backend has used both `price` and `Price` keys at different times.
    // Try both and coerce to a number.
    const value = nested?.price ?? nested?.Price
    if (value !== undefined) return Number(value)
  }

  // Legacy flat structure – backend originally returned `{ price: "123" }` or `{ Price: "123" }`.
  if (typeof data.price !== "undefined") return Number(data.price)
  if (typeof data.Price !== "undefined") return Number(data.Price)

  // If the function already responded with a primitive number, just return it.
  if (typeof data === "number") return data

  // Anything else is unexpected – log for debugging and return 0 to avoid NaN.
  console.warn("[getTokenPrice] Unrecognised response shape", data)
  return 0
}
